import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL } from '../../utils/constants';
import { getErrorMessage } from '../../utils/helper';

export const fetchScholarships = createAsyncThunk(
  'scholarship/fetchScholarships',
  async ({ page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}scholarship`, {
        params: { page, limit, search }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch scholarships'));
    }
  }
);

export const fetchScholarshipById = createAsyncThunk(
  'scholarship/fetchScholarshipById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}scholarship/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch scholarship details'));
    }
  }
);

export const createScholarship = createAsyncThunk(
  'scholarship/createScholarship',
  async (scholarshipData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}scholarship`, scholarshipData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to create scholarship'));
    }
  }
);

export const updateScholarship = createAsyncThunk(
  'scholarship/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}scholarship/${id}`, data);
      return response.data;
    } catch (error) {
      console.log("error", error);
      
      return rejectWithValue(getErrorMessage(error, 'Failed to update scholarship'));
    }
  }
);

export const addInstallment = createAsyncThunk(
  'scholarship/addInstallment',
  async ({ scholarshipId, amount, remark, installmentDate, accountId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}scholarship/${scholarshipId}/installments`, {
        amount,
        remark,
        installmentDate,
        accountId
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to add installment'));
    }
  }
); 

export const deleteScholarship = createAsyncThunk(
  "scholarship/delete",
  async (id, {rejectWithValue}) => {
    try {
      const response = await axiosInstance.delete(`${BASE_URL}scholarship/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Failed to delete scholarship"));
    }
  }
);
